/* eslint-disable no-undef */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ItemService from "../../../services/supplier_appCommonService";

const initialState = {
    data: [],
    budgetDetail: {},
    status: true,
    detailStatus: true,
    saveStatus: false,
    pagination: {
        page: "",
        per_page: "",
        total: ""
    }
};

export const budgetSlice = createSlice({
    name: "budget",
    initialState,
    reducers: {
        clearBudgetDetail(state, action) {
            state.budgetDetail = {};
            state.detailStatus = true;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getBudgetList.pending, (state, action) => {
                state.status = true;
            })
            .addCase(getBudgetList.fulfilled, (state, action) => {
                state.data = action.payload?.data || [];
                state.pagination.page = action.payload?.page;
                state.pagination.per_page = action.payload?.per_page;
                state.pagination.total = action.payload?.total;
                state.status = false;
            })
            .addCase(getBudgetList.rejected, (state, action) => {
                state.status = false;
            })
            .addCase(getBudgetDetail.pending, (state, action) => {
                state.detailStatus = true;
            })
            .addCase(getBudgetDetail.fulfilled, (state, action) => {
                state.budgetDetail = action.payload?.data || {};
                state.detailStatus = false;
            })
            .addCase(getBudgetDetail.rejected, (state, action) => {
                state.detailStatus = false;
            })
            .addCase(addBudget.pending, (state, action) => {
                state.saveStatus = true;
            })
            .addCase(addBudget.fulfilled, (state, action) => {
                state.saveStatus = false;
            })
            .addCase(addBudget.rejected, (state, action) => {
                state.saveStatus = false;
            })
            .addCase(updateBudget.pending, (state, action) => {
                state.saveStatus = true;
            })
            .addCase(updateBudget.fulfilled, (state, action) => {
                state.saveStatus = false;
            })
            .addCase(updateBudget.rejected, (state, action) => {
                state.saveStatus = false;
            })
    }
});

export const { clearBudgetDetail } = budgetSlice.actions;
export default budgetSlice.reducer;

export const getBudgetList = createAsyncThunk('getBudgetList', async (param) => {
    console.log(">> loaded getBudgetList");
    const res = await ItemService.getBudgetList(param);
    return res;
})

export const getBudgetDetail = createAsyncThunk('getBudgetDetail', async (param) => {
    console.log(">> loaded getBudgetDetail");
    const res = await ItemService.getBudgetDetail(param);
    return res;
})

export const addBudget = createAsyncThunk('addBudget', async (param) => {
    console.log(">> loaded addBudget");
    const res = await ItemService.addBudget(param);
    return res;
})

export const updateBudget = createAsyncThunk('updateBudget', async (param) => {
    console.log(">> loaded updateBudget");
    const res = await ItemService.updateBudget(param);
    return res;
})

export const deleteBudget = createAsyncThunk('deleteBudget', async (param) => {
    console.log(">> loaded deleteBudget");
    const res = await ItemService.deleteBudget(param);
    return res;
})
